export const primaryBlueDark = '#345B83';
export const lightBlue = '#0065FC';
export const whiteColor = '#FFFFFF';
export const pageBackColor = '#E5E5E5';
export const themePink = '#8651D9';
export const blackColor = '#000000';
export const lightgray = '#FAFAFA';
export const shadowColor = '#00000026';
export const lightShadow = '#97979726';
export const themegreen = '#10D35E';
export const lightShadowBlue = '#F7F8F7';
export const themeRed = '#F94839';
export const themeGray = '#585858';
export const themelightGray = '#C2C2C2';
export const themedarkGray = '#666666';
export const AgentDashboardLoco = '#200E32';
export const AgentDashboardAddress = '#200E32';
export const AgentDashboardWatchingTwelve = '#656565';
